module.exports = __webpack_public_path__ + "static/media/Level_three.a2c6e10f.svg";